<ng-container *ngIf="isLoaded; else loaderBlock">
  <div
    class="landing"
    *transloco="let t">
    <div
      class="landing_hero __full-screen"
      appBackgroundBranded>
      <div class="landing_hero_main __wide">
        <!-- If user follows invitation link with it disabled in admin panel -->
        <div class="fb-panel">
          <app-company-logo class="fb-panel_logo"></app-company-logo>

          <h2
            class="fb-panel_title"
            style="margin-bottom: 0"
            [innerHTML]="t('registration.user.invitation-link-off', { companyName: company.name })"></h2>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #loaderBlock>
  <app-icon
    class="layout_spinner"
    name="spinner"></app-icon>
</ng-template>
